const defaultState = { error: null }

const set = (error) => ({ error })
const clear = () => defaultState
const hasErrorToDisplay = (state) => !!(state.error)

const dialogState = { defaultState, set, clear, hasErrorToDisplay }
export default dialogState
